module.exports = __webpack_public_path__ + "img/ring_g_e_null_null.357df9ec.png";